// refundListSlice.js
import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../apiSlice";
import { buildQueryString } from "../../utils/buildQueryString";

/* =========================
   Adapter
========================= */

const refundsAdapter = createEntityAdapter({
  selectId: (refund) => refund.id,
});

const initialState = refundsAdapter.getInitialState();

/* =========================
   API Slice
========================= */

export const refundListSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    /* -------- GET REFUND LIST -------- */
    getRefundList: builder.query({
      query: (filters = {}) =>
        buildQueryString("refund_orders", filters),

      transformResponse: (response) => {
        const normalized = (response.data ?? []).map((item) => ({
          ...item,
        }));

        return refundsAdapter.setAll(initialState, normalized);
      },

      providesTags: (result) => [
        { type: "Refunds", id: "LIST" },
        ...(result?.ids ?? []).map((id) => ({
          type: "Refunds",
          id,
        })),
      ],
    }),

    /* -------- GET REFUND BY ID -------- */
    getRefundById: builder.query({
      query: (refundId) => `refund_orders/${refundId}`,

      transformResponse: (response) =>
        response?.data ?? null,

      providesTags: (result, error, id) => [
        { type: "Refunds", id },
      ],
    }),

    /* -------- PATCH REFUND STATUS (optional future use) -------- */
    // patchRefundStatus: builder.mutation({
    //   query: ({ id, status, remarks }) => ({
    //     url: `refund_orders/${id}`,
    //     method: "PATCH",
    //     body: { status, remarks },
    //   }),
    //
    //   invalidatesTags: (result, error, { id }) => [
    //     { type: "Refunds", id },
    //     { type: "Refunds", id: "LIST" },
    //   ],
    // }),

  }),
});

/* =========================
   Hooks
========================= */

export const {
  useGetRefundListQuery,
  useGetRefundByIdQuery,
  // usePatchRefundStatusMutation,
} = refundListSlice;


/* =========================
   Filter Selector
========================= */

const selectRefundFilter = (state) => state.refundFilter;


/* =========================
   Query Arg Selector (STANDARD)
========================= */

export const selectRefundQueryArg = createSelector(
  [selectRefundFilter],
  (filter) => ({
    status: filter.status,
    search: filter.search,
  })
);


/* =========================
   Query Result Selector
========================= */

const selectRefundQueryResult = createSelector(
  [selectRefundQueryArg, (state) => state],
  (filters, state) =>
    refundListSlice.endpoints.getRefundList.select(filters)(state)
);


/* =========================
   Data Selector
========================= */

const selectRefundData = createSelector(
  [selectRefundQueryResult],
  (queryResult) => queryResult?.data ?? initialState
);


/* =========================
   Adapter Selectors
========================= */

export const {
  selectAll: selectRefunds,
  selectById: selectRefundById,
  selectIds: selectRefundIds,
} = refundsAdapter.getSelectors((state) =>
  selectRefundData(state)
);